{
  "fontSizeBase": "16px",
  "colorNeutral15": "#D8D8D8",
  "colorNeutral20": "#D8D8D8",
  "colorNeutral30": "#B2B2B2",
  "colorNeutral40": "#90969A",
  "colorNeutral60": "#5E666B",
  "colorNeutral80": "#2F3A40",
  "colorNeutralDefault": "#111416",
  "colorNeutralWhite": "#FFFFFF",
  "colorNeutral02": "#FBFBFB",
  "colorNeutral03": "#FBFBFB",
  "colorNeutral05": "#F2F2F2",
  "colorBrand1Active": "#003242",
  "colorBrand1Base": "#004455",
  "colorBrand1Hover": "#004455",
  "colorBrand1Tint": "#F2FAFC",
  "colorBrand1Highlight": "#D7E9EB",
  "colorBrand2Active": "#DE843D",
  "colorBrand2Base": "#E9A165",
  "colorBrand2Hover": "#FFFFFF",
  "colorBrand2Tint": "#FFFFFF",
  "colorActionActive": "#004562",
  "colorActionBase": "#006586",
  "colorActionHover": "#5EB5D5",
  "colorActionTint": "#FBFBFB",
  "colorMessageSuccessBase": "#088463",
  "colorMessageSuccessHover": "#006A4A",
  "colorMessageSuccessTint": "#E3F0EC",
  "colorMessageWarningBase": "#FCBF38",
  "colorMessageWarningHover": "#FCBF38",
  "colorMessageWarningTint": "#FFF8E8",
  "colorMessageErrorBase": "#BE4025",
  "colorMessageErrorHover": "#FCEDED",
  "colorMessageErrorTint": "#FDF5F5",
  "colorDecPurple10": "#E7E9F4",
  "colorDecPurple15": "#E7E9F4",
  "colorDecPurple100": "#9FA7D4",
  "colorDecPurple150": "#292B60",
  "colorDecTurquoise10": "#D7E9EB",
  "colorDecTurquoise20": "#BAD6DE",
  "colorDecTurquoise30": "#98C4CB",
  "colorDecTurquoise40": "#6BA8AD",
  "colorDecTurquoise60": "#007A84",
  "colorDecTurquoise80": "#007A84",
  "colorDecTurquoise100": "#005D66",
  "colorDecTurquoise03": "#F2FAFC",
  "colorDecTurquoise05": "#F2FAFC",
  "colorDecIndigo05": "#F3F4F9",
  "colorDecIndigo10": "#E7E9F4",
  "colorDecIndigo15": "#E7E9F4",
  "colorDecIndigo30": "#C5C9E1",
  "colorDecIndigo50": "#6069A8",
  "colorDecIndigo60": "#4C5693",
  "colorDecIndigo80": "#38427F",
  "colorDecIndigo100": "#818ECE",
  "colorDecIndigo200": "#4C5693",
  "colorDecBlue10": "#D6E4EF",
  "colorDecBlue15": "#E2EDF3",
  "colorDecBlue100": "#326EB1",
  "colorDecCyan10": "#D0EEF3",
  "colorDecCyan100": "#23ACCB",
  "colorDecKelly03": "#E3F0EC",
  "colorDecKelly10": "#D8ECE7",
  "colorDecKelly100": "#7BB190",
  "colorDecGreen10": "#E3F0EC",
  "colorDecGreen15": "#D8ECE7",
  "colorDecGreen30": "#7BB190",
  "colorDecGreen50": "#088463",
  "colorDecGreen60": "#006A4A",
  "colorDecGreen100": "#479672",
  "colorDecYellow02": "#FFF8E8",
  "colorDecYellow03": "#FFF8E8",
  "colorDecYellow10": "#FEF0CF",
  "colorDecYellow15": "#FEF0CF",
  "colorDecYellow60": "#FCBF38",
  "colorDecYellow40": "#FDD77F",
  "colorDecYellow100": "#FBCA5E",
  "colorDecOrange10": "#F9D9BF",
  "colorDecOrange100": "#D56D1F",
  "colorDecRed10": "#F5E0DC",
  "colorDecRed15": "#F5E0DC",
  "colorDecRed60": "#BE4025",
  "colorDecRed70": "#982C0E",
  "colorDecRed100": "#DA6D50",
  "colorDecBrown100": "#8E4F17",
  "colorDecBlack30": "#111416",
  "colorDecSandElevationMinus1": "#E7DBD0",
  "colorDecSandElevation0": "#F3EEE9",
  "colorDecSandElevation1": "#FDFBF7",
  "colorDecSandElevation2": "#FFFEFD",
  "colorAccessibilityFocusDefault": "#185998",
  "colorNeutral700": "#5E666B",
  "colorNeutral800": "#2F3A40",
  "colorNeutral900": "#192124",
  "colorNeutral950": "#111416",
  "colorNeutralBlack": "#000000",
  "colorSand100": "#FDFBF7",
  "colorSand200": "#F3EEE9",
  "colorSand300": "#E7DBD0",
  "colorSand350": "#DACBBD",
  "colorSand600": "#685F57",
  "colorSand800": "#332D26",
  "colorTerra50": "#F8F1EB",
  "colorTerra100": "#F5EAE1",
  "colorTerra300": "#E9D0BD",
  "colorTerra700": "#8E4F17",
  "colorTerra800": "#5F310F",
  "colorTeal100": "#D7E9EB",
  "colorTeal200": "#BAD6DE",
  "colorTeal800": "#003242",
  "colorBlue100": "#D6E4EF",
  "colorBlue200": "#A6C2DB",
  "colorBlue300": "#79A2C8",
  "colorBlue600": "#185998",
  "colorIndigo100": "#E7E9F4",
  "colorIndigo600": "#4C5693",
  "colorIndigo700": "#38427F",
  "colorGreen200": "#A6CFBE",
  "colorGreen500": "#088463",
  "colorGreen600": "#006A4A",
  "colorGreen700": "#005134",
  "colorYellow700": "#AC7600",
  "colorYellow800": "#825601",
  "colorWarningDark": "#AD6E00",
  "colorRed700": "#7B1500",
  "colorTextPrimary": "#192124",
  "colorTextPrimaryDefault": "#4C5693",
  "colorTextSecondary": "#5F6777",
  "colorTextNeutralSecondary": "#5E666B",
  "colorTextNeutralDisabled": "#B2B2B2",
  "colorTextWarningDefault": "#825601",
  "colorTextNegativeDefault": "#7B1500",
  "colorMainAction": "#0D6A97",
  "colorInteractivePrimary": "#326BDC",
  "elevation01": "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "elevation04": "0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)",
  "elevation08": "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.2)",
  "dropShadow01": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  "dropShadow02": "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10)",
  "dropShadow03": "0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)",
  "dropShadow04": "0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)",
  "dropShadow05": "0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10)",
  "dropShadow06": "0px 25px 50px -12px rgba(0, 0, 0, 0.25)",
  "dropShadow07": "0px 25px 50px 0px rgba(0, 0, 0, 0.08)",
  "innerShadow01": "0 2px 4px 0 rgba(0, 0, 0, 0.05) inset",
  "spacing00": "0px",
  "spacing01": "0.25rem",
  "spacing02": "0.5rem",
  "spacing03": "1rem",
  "spacing04": "1.5rem",
  "spacing05": "2rem",
  "spacing06": "2.5rem",
  "spacing07": "3rem",
  "spacing08": "3.5rem",
  "fontFamilyInclusiveSans": "Inclusive Sans",
  "fontFamilyLora": "lora",
  "fontFamilyFallback": "Arial",
  "fontLetterSpacing00": "normal",
  "fontLetterSpacing01": "0.005em",
  "fontLetterSpacing02": "0.01em",
  "fontLetterSpacing03": "0.0125em",
  "fontLetterSpacing04": "0.0325em",
  "fontLineHeight10": "3.5rem",
  "fontLineHeight01": "0.875rem",
  "fontLineHeight02": "1rem",
  "fontLineHeight03": "1.125rem",
  "fontLineHeight04": "1.25rem",
  "fontLineHeight05": "1.375rem",
  "fontLineHeight06": "1.5rem",
  "fontLineHeight07": "1.75rem",
  "fontLineHeight08": "2rem",
  "fontLineHeight09": "2.25rem",
  "fontSize01": "0.625rem",
  "fontSize02": "0.75rem",
  "fontSize03": "0.875rem",
  "fontSize04": "1rem",
  "fontSize05": "1.125rem",
  "fontSize06": "1.25rem",
  "fontSize07": "1.5rem",
  "fontSize08": "1.75rem",
  "fontSize09": "2.25rem",
  "fontSize10": "3rem",
  "fontWeightLight": "300",
  "fontWeightNormal": "400",
  "fontWeightMedium": "500",
  "fontWeightSemibold": "600",
  "fontWeightBold": "700",
  "breakpointXs": "599px",
  "breakpointSm": "959px",
  "breakpointTablet": "1149px",
  "breakpointMd": "1439px",
  "breakpointLg": "1919px",
  "mediaQueryExpressionAll": "all",
  "mediaQueryExpressionPrint": "print",
  "mediaQueryExpressionScreen": "screen",
  "mediaQueryExpressionSpeech": "speech",
  "mediaQueryExpressionLandscape": "'(orientation: landscape)'",
  "mediaQueryExpressionPortrait": "'(orientation: portrait)'",
  "mediaQueryUnitIntervalsPx": "1",
  "mediaQueryUnitIntervalsEm": "0.01",
  "mediaQueryUnitIntervalsRem": "0.1",
  "borderRadius00": "0",
  "borderRadius01": "0.125rem",
  "borderRadius02": "0.25rem",
  "borderRadius03": "0.5rem",
  "borderRadius04": "1rem",
  "borderRadius045": "1.25rem",
  "borderRadius05": "1.5rem",
  "borderRadius06": "2rem",
  "borderRadiusFull": "50%",
  "colorNeutral50": "#FFFFFF",
  "colorNeutral100": "#FBFBFB",
  "colorNeutral200": "#F2F2F2",
  "colorNeutral300": "#E4E3E0",
  "colorNeutral400": "#D8D8D8",
  "colorNeutral500": "#B2B2B2",
  "colorNeutral600": "#90969A",
  "colorSand50": "#FFFEFD",
  "colorSand400": "#B9AEA4",
  "colorSand500": "#90867D",
  "colorSand700": "#484039",
  "colorSand900": "#211D18",
  "colorSand950": "#181613",
  "colorRed50": "#FDF5F5",
  "colorRed100": "#FCEDED",
  "colorRed200": "#F5E0DC",
  "colorRed300": "#F4A996",
  "colorRed400": "#DA6D50",
  "colorRed500": "#BE4025",
  "colorRed600": "#982C0E",
  "colorRed800": "#5B0500",
  "colorRed900": "#3A0100",
  "colorRed950": "#290200",
  "colorTerra200": "#EEDCCD",
  "colorTerra400": "#DAA87E",
  "colorTerra500": "#C18144",
  "colorTerra600": "#AA661C",
  "colorTerra900": "#3D210B",
  "colorTerra950": "#281B11",
  "colorYellow50": "#FFF8E8",
  "colorYellow100": "#FEF0CF",
  "colorYellow200": "#FDDF9B",
  "colorYellow300": "#FDD77F",
  "colorYellow400": "#FBCA5E",
  "colorYellow500": "#FCBF38",
  "colorYellow600": "#D69905",
  "colorYellow900": "#412D15",
  "colorYellow950": "#221A11",
  "colorGreen50": "#E3F0EC",
  "colorGreen100": "#D8ECE7",
  "colorGreen300": "#7BB190",
  "colorGreen400": "#479672",
  "colorGreen800": "#003920",
  "colorGreen900": "#012210",
  "colorGreen950": "#03160A",
  "colorTeal50": "#F2FAFC",
  "colorTeal300": "#98C4CB",
  "colorTeal400": "#6BA8AD",
  "colorTeal500": "#007A84",
  "colorTeal600": "#005D66",
  "colorTeal700": "#004455",
  "colorTeal900": "#001B25",
  "colorTeal950": "#001219",
  "colorCyan50": "#EDFDFE",
  "colorCyan100": "#D0EEF3",
  "colorCyan200": "#ABDAE9",
  "colorCyan300": "#8AC5E3",
  "colorCyan400": "#5EB5D5",
  "colorCyan500": "#23ACCB",
  "colorCyan600": "#0088AA",
  "colorCyan700": "#006586",
  "colorCyan800": "#004562",
  "colorCyan900": "#002740",
  "colorCyan950": "#001931",
  "colorBlue50": "#E2EDF3",
  "colorBlue400": "#5083B7",
  "colorBlue500": "#326EB1",
  "colorBlue700": "#00447E",
  "colorBlue800": "#00325D",
  "colorBlue900": "#001F40",
  "colorBlue950": "#001734",
  "colorIndigo50": "#F3F4F9",
  "colorIndigo200": "#C5C9E1",
  "colorIndigo300": "#9FA7D4",
  "colorIndigo400": "#818ECE",
  "colorIndigo500": "#6069A8",
  "colorIndigo800": "#292B60",
  "colorIndigo900": "#1A173B",
  "colorIndigo950": "#120F29",
  "colorOrange50": "#FDF0E6",
  "colorOrange100": "#F9D9BF",
  "colorOrange200": "#F2BE91",
  "colorOrange300": "#E9A165",
  "colorOrange400": "#DE843D",
  "colorOrange500": "#D56D1F",
  "colorOrange600": "#B95712",
  "colorOrange700": "#934000",
  "colorOrange800": "#6D2C00",
  "colorOrange900": "#421900",
  "colorOrange950": "#261003",
  "colorDecIndigo40": "#C5C9E1",
  "colorNeutralBlackOpacity04": "#0000000A"
}
